import { h, Component } from 'preact';
import { Role, User } from '../../../../types';
import * as roles from '../../../core/roles';

import { navigatorGo } from '../../../utils/navigator';
import getStore from '../../store';
import * as InquiriesActions from '../../reducers/inquiries/inquiries.actions';

export interface NavbarProps {
  sidenavMenuCallback: Function;

  baseUrl: string;
  currentRoute: string;
  currentUser?: User;
}

export interface NavbarState {
  isUserSD?: boolean;
}

export class Navbar extends Component<NavbarProps, NavbarState> {
  componentWillReceiveProps(props: NavbarProps) {
    if (props.currentUser) {
      this.setState({
        isUserSD: roles.userHasRole(props.currentUser, Role.SALES_DIRECTOR)
      });
    }
  }

  onMenuButtonClicked = () => {
    this.props.sidenavMenuCallback();
    
  }

  onPostPropertyClick = (location: string) => {
    navigatorGo(location);
  }

  onAddClientClick() {
    getStore().dispatch(InquiriesActions.showModal('add-client', {}));
  }

  getButtons(props: NavbarProps, state: NavbarState) {
    if (state.isUserSD && props.currentRoute.includes('post-property')) {
      return (
        <div className={`
          col-6 col-xl-4 offset-xl-6 
          hi-kumita-navbar__post-property 
          d-flex justify-content-center
          d-md-flex justify-content-md-end
        `}>
        <button className="btn btn-secondary d-none d-md-block" onClick={() => this.onPostPropertyClick('/dashboard/add-property')}>
          Post Property on Kumita V1
        </button>

        <button className="btn btn-secondary d-md-none" onClick={() => this.onPostPropertyClick('/dashboard/add-property')}>
          Post on Kumita V1
        </button>
      </div>
      );
    } else {
      return (
        <div className="d-flex">
          <button type="button" className="btn btn-link hi-kumita-navbar__button d-md-none"
            onClick={ () => this.onPostPropertyClick(`/${props.baseUrl}/post-property`) }>
            <i className="fas fa-home hi-kumita-navbar__button-icon-large" />
            <i className="fas fa-plus hi-kumita-navbar__button-icon-small hi-kumita-navbar__plus-icon" />
          </button>

          <button type="button" className="btn btn-link hi-kumita-navbar__button d-md-none"
            onClick={ () => this.onAddClientClick() }>
            <i className="fas fa-user-plus hi-kumita-navbar__button-icon-large text-secondary" />
          </button>

          <button className="btn btn-outline-dark mr-2 d-none d-md-block"
            onClick={ () => this.onPostPropertyClick(`/dashboard/mybusiness`) }>
            Go to Kumita V1
          </button>

          <button className="btn btn-outline-dark d-none d-md-block mr-2"
            onClick={ () => this.onPostPropertyClick(`/${props.baseUrl}/post-property`) }>
            Post Property
          </button>

          <button className="btn btn-secondary d-none d-md-block"
            onClick={ () => this.onAddClientClick() }>
            Add Client
          </button>
        </div>
      );
    }

  }

  render(props: NavbarProps, state: NavbarState) {
    const logoBaseSrc = `//hoppler-inc.imgix.net/hoppler/pages/static/kumita-logo.png?auto=format&w=128`;

    return (
      <div className="hi-kumita-navbar">
        <div className="hi-kumita-navbar__contents d-flex align-items-center">
          <button className="btn btn-icon d-lg-none h-100 hi-kumita-navbar__hamburger" onClick={ this.onMenuButtonClicked }>
            <i className="fas fa-bars"></i>
          </button>
          <a href="/dashboard/mylistings" className="hi-kumita-navbar__logo-link">
            <img src={ logoBaseSrc }
              srcset={`
                ${logoBaseSrc} 1x,
                ${logoBaseSrc}&dpr=1.5 1.5x,
                ${logoBaseSrc}&dpr=2 2x,
                ${logoBaseSrc}&dpr=3 3x,
                ${logoBaseSrc}&dpr=4 4x,
              `}

              className="hi-kumita-navbar__logo-img"
              alt="kumita_logo" />
          </a>

          <div className="flex-fill" />
            
          { this.getButtons(props, state) }
        </div>

        {/* Prevent elements from occupying the space underneath the navbar */}
        <div className="hi-kumita-navbar__padding">
        </div>
      </div>
    );
  }
} 